<template>
  <el-autocomplete popper-class="select-option" v-model="value" :fetch-suggestions="loadData" @select="onSelect" @clear="onClear" placeholder="姓名/电话查找人员" value-key="Name" v-bind="$attrs">
    <template slot-scope="{ item }">
      <label>{{ item.Name }}</label>
      <label class="text-sm text-info">{{ item.Dept.Name }}</label>
    </template>
  </el-autocomplete>
</template>

<script>
export default {
  props: {
    value: { type: String }
  },
  methods: {
    loadData (key = null, cb) {
      this.$apis.organize.staff.list({
        keyWord: key,
        index: 1,
        size: 10
      }).then(res => {
        cb(res.Items.map(x => {
          return {
            Id: x.Id,
            Name: x.Name,
            Phone: x.Phone,
            Dept: x.Dept,
            Account: x.Account
          }
        }))
      })
    },
    onSelect (e) {
      this.$emit('selectHandler', e)
    },
    onClear () {
      this.$emit('selectHandler', {})
    }
  }
}
</script>

<style lang="scss">
.select-option {
  li {
    display: flex;
    justify-content: space-between;
  }
}
</style>
